export default __webpack_public_path__ + "static/media/mobile-bleck.9c964ce0.png";